<template>
  <v-dialog v-model="dialog" max-width="600px" @click.stop persistent style="z-index: 3000;">
    <v-card @click.stop>
      <DialogTitleBar>
        설정 넣어두기
        <template #actions>
          <v-btn icon variant="text" aria-label="닫기" @click="closeDialog">
            <svg-icon type="mdi" :path="icons.mdiClose" />
          </v-btn>
        </template>
      </DialogTitleBar>
      <v-card-text class="store-prompt-body">
        <p class="store-prompt-description">
          현재 시스템 설정을 제목과 설명으로 저장해 나중에 다시 가져올 수 있습니다.
        </p>
        <v-form ref="form">
          <v-text-field
            v-model="title"
            label="제목"
            maxlength="14"
            counter
            required
            variant="underlined"
            :rules="[
              (v) => !!v || '제목을 입력하세요.',
              (v) => v.length <= 14 || '제목은 14자 이내여야 합니다.',
            ]"
          />
          <v-textarea
            v-model="description"
            label="설명"
            rows="1"
            counter
            maxlength="50"
            variant="underlined"
            :rules="[
              (v) => !!v || '설명을 입력하세요.',
              (v) => v.length <= 50 || '설명은 50자 이내여야 합니다.',
            ]"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="savePrompt">넣어두기</v-btn>
        <v-btn variant="text" @click="closeDialog">취소</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogTitleBar from '@/components/DialogTitleBar.vue';
import icons from '@/icons';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/firebase';

export default {
  components: {
    DialogTitleBar,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue', 'showSnackbar', 'preventDrawerClose'],
  data() {
    return {
      icons,
      dialog: false,
      title: '',
      description: '',
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.dialog = value;
        if (!value) {
          this.resetForm();
        }
      },
    },
    dialog(value) {
      this.$emit('update:modelValue', value);
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    resetForm() {
      this.title = '';
      this.description = '';
      this.$refs.form?.resetValidation();
    },
    async savePrompt() {
      const validation = await this.$refs.form?.validate();
      if (validation && validation.valid === false) {
        return;
      }
      if (this.title.length > 14) {
        this.$emit('showSnackbar', '제목은 14자 이내로 입력해주세요.', 'error');
        return;
      }

      try {
        if (!this.userId || !this.settings || Object.keys(this.settings).length === 0) {
          this.$emit('showSnackbar', '필수 데이터가 누락되었습니다.', 'error');
          return;
        }

        const userStoredPromptsRef = collection(db, 'users', this.userId, 'storedPrompts');

        await addDoc(userStoredPromptsRef, {
          title: this.title,
          description: this.description,
          settings: this.settings,
          createdAt: serverTimestamp(),
        });
        this.$emit('showSnackbar', '설정이 저장되었습니다.', 'success');
        this.$emit('preventDrawerClose');
        this.closeDialog();
        this.resetForm();
      } catch (error) {
        console.error('설정을 저장하는 중 오류가 발생했습니다.', error);
        this.$emit('showSnackbar', '설정을 저장하는 중 오류가 발생했습니다.', 'error');
      }
    },
  },
};
</script>

<style scoped>
.store-prompt-body {
  padding-top: 6px;
}

.store-prompt-description {
  margin-bottom: 18px;
  font-size: 0.94rem;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.64);
}
</style>
